import produce from 'immer';
import Cookies from 'cookies-js';

import AccountTypes from '~/constants/types/AccountTypes';
import DesignTypes from '~/constants/types/DesignTypes';

import {Statuses} from '~/utils/status';
import {INTERNAL_USER_FLAG} from '~/utils/user';

const SDFU_COOKIE_FLAG = 'savedBefore';

export function initialState() {
  return {
    country: null,
    internal: Cookies.get(INTERNAL_USER_FLAG) === 'true',
    orderedBefore: null,
    preferSingles: false,
    savedBefore: !!Cookies.get(SDFU_COOKIE_FLAG),
    savedDesigns: [],
    savedDesignsStatus: Statuses.Idle,
    selectedSavedDesignIndex: null,
    hasMoreSavedDesigns: false
  };
}

export default function account(state = initialState(), action) {
  switch (action.type) {
    case AccountTypes.LOCATION_LOADED:
      return produce(state, draft => {
        draft.country = action.payload;
      });
    case AccountTypes.SELECT_SAVED_DESIGN_INDEX:
      return produce(state, draft => {
        draft.selectedSavedDesignIndex = action.payload.savedDesignIndex;
      });
    case AccountTypes.UPDATE_PROFILE: {
      const {orderedBefore} = action.payload;
      return produce(state, draft => {
        draft.orderedBefore = orderedBefore;
      });
    }
    case AccountTypes.UPDATE_INTERNAL_USER: {
      switch (action.payload) {
        case 'internal':
          Cookies.set(INTERNAL_USER_FLAG, true);
          return produce(state, draft => {
            draft.internal = true;
          });
        case 'external':
          Cookies.set(INTERNAL_USER_FLAG, false);
          return produce(state, draft => {
            draft.internal = false;
          });
        default:
          return state;
      }
    }
    case AccountTypes.FETCH_SAVED_DESIGNS_START: {
      return produce(state, draft => {
        draft.savedDesignsStatus = Statuses.Pending;
      });
    }
    case AccountTypes.FETCH_SAVED_DESIGNS_SUCCESS: {
      const savedDesigns = action.payload.designs;
      const page = action.payload.page;

      return produce(state, draft => {
        draft.hasMoreSavedDesigns = action.payload.hasMoreSavedDesigns;
        draft.savedDesignsStatus = Statuses.Resolved;

        if (page === 1 && state.savedDesigns.length > 0) {
          const list = draft.savedDesigns.slice(
            savedDesigns.length,
            state.savedDesigns.length
          );
          draft.savedDesigns = savedDesigns.concat(list);
        } else {
          draft.savedDesigns = draft.savedDesigns.concat(savedDesigns);
        }
      });
    }
    case AccountTypes.FETCH_SAVED_DESIGNS_FAILED: {
      return produce(state, draft => {
        draft.hasMoreSavedDesigns = false;
        draft.savedDesignsStatus = Statuses.Rejected;
      });
    }
    case DesignTypes.SAVE_SUCCESS:
      if (typeof window.FS !== 'undefined') {
        window.FS.identify(action.payload.email);
      }
      if (!state.savedBefore) {
        Cookies.set(SDFU_COOKIE_FLAG, true);
      }
      return produce(state, draft => {
        draft.savedBefore = true;
      });
    case AccountTypes.SET_PREFER_SINGLES:
      return produce(state, draft => {
        draft.preferSingles = action.payload;
      });
    default:
      return state;
  }
}
